module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast3#toc1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("It is with deep gratitude that I thank all those who have helped to shape my feminist consciousness and who have taught me ways of feminist biblical interpretation: my mother, Christine F. Reid, whose keen sense of equal dignity for all remains ever a part of me; my first teachers and now my companions in life and mission, the Dominican Sisters of Adrian and Grand Rapids, Michigan; my professors at the Catholic University of America, especially Elizabeth Johnson and Mary Ann Getty Sullivan; my colleagues, students, and staff at Catholic Theological Union, who continue to stretch and support me; and countless scholars and friends whose insights and wisdom constantly open new horizons for me.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eee93e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reid_Wisdoms_Feast-4.vue
// module id = 66
// module chunks = 0